import * as React from "react";
import { Button, Modal } from "react-bootstrap";
import ApiRequestButton from "../sub-components/ApiRequestButton";

type Props = {
  title?: string;
  show?: boolean;
  primaryButtonName: string;
  secondaryButtonName: string;
  primaryAction: () => void;
  onModalClose: () => void;
  disablePrimaryButton: boolean;
  children: JSX.Element;
};

const CCModal = ({title, show,  primaryButtonName, secondaryButtonName, primaryAction, onModalClose, disablePrimaryButton, children}:Props)=> {
    return (
        <Modal show={show} onHide={onModalClose} size="sm"
                    aria-labelledby="contained-modal-title-vcenter"
                            keyboard={false}
                  >
                    <Modal.Header closeButton={false} className="cc-modal-header">
                      <Modal.Title id="contained-modal-title-vcenter" className="cc-modal-title">
                        {title}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div>
                        {children}
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="modal-button" onClick={onModalClose}>{secondaryButtonName}</Button>
                        <ApiRequestButton css="modal-button" tag={primaryButtonName} disabled={disablePrimaryButton} onButtonClick={primaryAction}/>
                    </Modal.Footer>
                    </Modal>
        );
    };

export default CCModal;